module.exports = "<div style=\"margin-left: -15px; margin-right: -15px;\">\r\n  <grid-view></grid-view>\r\n</div>\r\n";